<template>
<div>
<v-btn absolute dark fab top right color="primary" style="top:10px;" @click="productDialog = true">
    <v-icon color="black">add</v-icon>
</v-btn>
<productForm :dialog="productDialog" @setDialog="productDialog = $event" 
:editedIndex="editedIndex" 
@setEditIndex="editedIndex = $event"/>
<v-data-table :headers="headers" :items="users" :pagination.sync="pagination" hide-actions>
    <template slot="items" slot-scope="props">
    <td class="text-xs-center">{{ props.item.product_code }}</td>
    <td style="padding:6px 0 0 0;"><img :src="props.item.img" width="100px" height="100px"></td>
    <td class="text-xs-center">{{ props.item.product_name }}</td>
    <td class="text-xs-center">{{ props.item.store_name }}</td>
    <td class="text-xs-center">{{ props.item.sale_price }}</td>
    <td class="text-xs-center">{{ props.item.base_price }}</td>
    <td style="padding:0;">
        <v-btn small color="primary" class="black--text">approve</v-btn>
    </td>
    <td class="px-0">
        <v-btn icon @click="editProduct()">
        <v-icon small>
        edit
        </v-icon>
        </v-btn>
        <v-btn icon>
        <v-icon small>
        delete
        </v-icon>
        </v-btn>
    </td>
</template>

<template slot="no-data">
    <v-btn color="primary" @click="initialize">Reset</v-btn>
</template>

</v-data-table>

 <!-- <div class="text-xs-center py-2">
      <v-pagination circle v-model="pagination.page" :length="pages"></v-pagination>
</div> -->
  </div>
</template>

<script>
import productForm from './ProductForm.vue'
    export default {
        data: () => ({
            productDialog : false,
            dialog: false,
            editedIndex: -1,
            pagination: {
                rowsPerPage:10
            },
            headers: [
                {
                    text: 'Product Code',
                    align: 'center',
                    value: 'product_code'
                },
                {
                    text: 'Image',
                    align: 'center',
                    value: 'img',
                    sortable: false
                },
                {
                    text: 'Product Name',
                    align: 'center',
                    value: 'product_name',
                    sortable: false
                },
                {
                    text: 'Store Name',
                    align: 'center',
                    value: 'store_name',
                    sortable: false
                },
                ,
                {
                    text: 'Sale Price',
                    align: 'center',
                    value: 'sale_price',
                    sortable: false
                },
                {
                    text: 'Base Price',
                    align: 'center',
                    value: 'base_price',
                    sortable: false
                },
                {
                    text: 'Approve',
                    align: 'center',
                    value: 'approve',
                    sortable: false
                },
                {
                    text: 'Actions',
                    align: 'center',
                    value: 'action',
                    sortable: false
                }
            ]
           
        }),
        components:{
            productForm
        },
        computed: {
            pages () {
                if (this.pagination.rowsPerPage == null ||
                this.pagination.totalItems == null
                ) return 0

                return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
            }
        },
    
        watch: {
            dialog(val) {
                val || this.close()
            }
        },
    
        created() {
            this.initialize()
        },
    
        methods: {
            initialize() {
                this.users = [{
                        product_code: '1234',
                        img: require('@/assets/back-office/p-trang.png'),
                        product_name: 'กล้วยน้ำว้าทอด',
                        store_name: 'กล้วยน้ำว้า',
                        sale_price: '50',
                        base_price: '60',
                        approve: '',
                        action: ''
                    }
                ]
            },
            editProduct() {
            this.productDialog = true;
            this.editedIndex = 1;
            }
        }
    }
</script>

